import React, { Component } from 'react';
import { Link } from 'react-router';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import Bugsnag from '../../helpers/bugsnag';
import { getLocations } from '../../utils/utils';
import { getLocationsList } from '../../common/globals';

class Locations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      locations: [],
      selectedLocation: '',
      active: null
    };
  }

  componentDidMount = async () => {
    const {
      online, notify
    } = this.props;

    if (online) {
      const locationsResponse = await getLocations();
      const locations = getLocationsList(locationsResponse.data);
      locations && this.setState({ locations });
    } else {
      notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 5 });
    }
  }

  _onSelectedLocation = (selectedData, index = null) => {
    try {
      const { onHideShowLocation } = this.props;
      const { active, isCaseType } = this.state;
      if (active === index) {
        this.setState({ active: null, selectedLocation: '' });
      } else {
        onHideShowLocation(selectedData);
        this.setState({ active: index, selectedLocation: selectedData, isCaseType: !isCaseType });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectedLocationIndex = (position) => {
    try {
      const { active } = this.state;
      if (active === position) {
        return 'selected';
      }
      return '';
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {

    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { locations } = this.state;
    // const locations = [
    //   { OptionName: 'Location 1' },
    //   { OptionName: 'Location 2' },
    // ];
    return (
      <section>
        <section className="section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <ul className="select-list list-unstyled cursor-pointer">
                  {
                    locations.length > 0
                      ? locations.map((data, index) => (
                        <Link
                          key={index}
                          onClick={() => { this._onSelectedLocation(data, index); }}
                        >
                          <li
                            className={this._onSelectedLocationIndex(index)}
                          >
                            {data.LocName}
                          </li>
                        </Link>
                      ))
                      : <div className="text-center">No locations available</div>
                  }
                </ul>
              </div>
            </div>
          </div>
        </section>
      </section>
    );
  }
}

export default withNotify(withLoader(Locations));
